import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { environment } from 'src/environments/environment';
import { ApiService, API_BASE_URL } from './core/services/api.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { routing } from './app.routing';
import { TexteService } from './core/services/texte.service';
import { ToolboxService } from './core/services/toolbox.service';
import { TotalFileSizePipe } from './core/total-file-size.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { IndicatifPipe } from './core/indicatif.pipe';

// Angular Material
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatMenuModule} from '@angular/material/menu';

// Components
import { AppComponent } from './app.component';
import { LayoutComponent } from './components/layout/layout.component';
import { FormulaireComponent, RECAPTCHA_KEY } from './components/formulaire/formulaire.component';
import { TypesSelectionComponent } from './components/formulaire/types-selection/types-selection.component';
import { PatientFormComponent } from './components/formulaire/patient-form/patient-form.component';
import { DemandeurFormComponent } from './components/formulaire/demandeur-form/demandeur-form.component';
import { ContactFormComponent } from './components/formulaire/contact-form/contact-form.component';
import { DemandeFormComponent } from './components/formulaire/demande-form/demande-form.component';
import { UploadFileCustomComponent } from './components/upload-file-custom/upload-file-custom.component';
import { MedecinFormComponent } from './components/formulaire/medecin-form/medecin-form.component';
import { RendezVousFormComponent } from './components/formulaire/rendez-vous-form/rendez-vous-form.component';
import { HistoriqueFormComponent } from './components/formulaire/historique-form/historique-form.component';
import { AllergieFormComponent } from './components/formulaire/allergie-form/allergie-form.component';
import { MentionsLegalesComponent } from './components/mentions-legales/mentions-legales.component';
import { LayoutService } from './core/services/layout.service';
import { ProtectionDonneesComponent } from './components/protection-donnees/protection-donnees.component';
import { SecondOpinionFrComponent } from './components/formulaire/second-opinion-fr/second-opinion-fr.component';
import { SecondOpinionInternationalComponent } from './components/formulaire/second-opinion-international/second-opinion-international.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    FormulaireComponent,
    TypesSelectionComponent,
    PatientFormComponent,
    DemandeurFormComponent,
    ContactFormComponent,
    DemandeFormComponent,
    UploadFileCustomComponent,
    MedecinFormComponent,
    RendezVousFormComponent,
    HistoriqueFormComponent,
    AllergieFormComponent,
    TotalFileSizePipe,
    IndicatifPipe,
    MentionsLegalesComponent,
    ProtectionDonneesComponent,
    SecondOpinionFrComponent,
    SecondOpinionInternationalComponent
  ],
  imports: [
    routing,
    BrowserModule,
    NgxSpinnerModule,
    RecaptchaModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatCardModule,
    MatTooltipModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatAutocompleteModule,
    FontAwesomeModule
  ],
  providers: [
    ApiService,
    { provide: API_BASE_URL, useValue: environment.API_BASE_URL },
    { provide: RECAPTCHA_KEY, useValue: environment.RECAPTCHA_KEY },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    MatDatepickerModule,
    TexteService,
    ToolboxService,
    LayoutService,
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
